import React from 'react';

import { useHawkSearch } from 'components/StoreProvider';
import Pager from './Pager';
import ItemsPerPage from './ItemsPerPage';
import { ScrollToResults } from 'features/search/FacetsAndResults';
import { useTranslation } from 'react-i18next';

function Pagination(props: ScrollToResults) {
	const { scrollToResults } = props;
	const { t } = useTranslation();

	const {
		store: { searchResults, pendingSearch },
		actor,
	} = useHawkSearch();

	function onPageChange(pageNo: number) {
		// when the pager's page changes, trigger a new search
		actor.setSearch({
			PageNo: pageNo,
		});

		scrollToResults(t('pagination'));
	}

	return (
		<div className="hawk-pagination">
			<ItemsPerPage scrollToResults={scrollToResults} />

			<Pager
				page={searchResults ? pendingSearch.PageNo || 1 : 0}
				totalPages={searchResults ? searchResults.Pagination.NofPages : 0}
				onPageChange={onPageChange}
			/>
		</div>
	);
}

export default Pagination;
